/** Dependencies */
import React from 'react';
import { Outlet } from 'react-router-dom';

function OperationLogsDetails() {
  return <Outlet />;
}

export default OperationLogsDetails;
